import { DataArray, IDataArray } from './../../shared/index';

export class Permission implements IDataArray {
    public Id: number;
    public Name: string;

    public GetById(): number {
        return this.Id;
    }
}
